// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	LoadingIcon: 'loading-icon',
	PhoneIcon: 'phone-icon',
	EmailIcon: 'email-icon',
	LocationIcon: 'location-icon',
	SearchInput: 'search-input',
	RecentMatterTile: 'recent-matter-tile',
	MatterTile: 'matter-tile',
	PhoneLink: 'phone-link',
	EmailLink: 'email-link',
	GoToClientDiv: 'go-to-client-div',
} as const;
